import { dismissDialog } from '../../../services/board-issue-move/index.tsx';
import 'rxjs/add/operator/ignoreElements';
import 'rxjs/add/operator/switchMap';
import {
	BOARD_ISSUE_MOVE_CANCEL,
	BOARD_ISSUE_MOVE_EXECUTE,
} from '../../../state/actions/board-issue-move/index.tsx';
import type { ActionsObservable, MiddlewareAPI } from '../../../state/types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(BOARD_ISSUE_MOVE_CANCEL, BOARD_ISSUE_MOVE_EXECUTE)
		.switchMap(() => dismissDialog(store.getState()).ignoreElements());
